import { auth } from "@/firebase";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/",
    name: "DashboardView",
    component: () => import("../views/DashboardView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/user",
    name: "user",
    component: () =>
      import("../components/masters/memberMaster/MemberList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/product",
    name: "product",
    component: () => import("../components/product/ProductList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/promotion",
    name: "promotion",
    component: () => import("../components/promotion/PromotionList.vue"),
    meta: { requiresAuth: true },
  },
    {
    path: "/videopromote",
    name: "videopromote",
    component: () => import("../components/videoPromote/VideoPromoteList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer",
    name: "customer",
    component: () => import("../components/customer/Customer.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customers/:id",
    component: () => import("../components/customer/Customer.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/groupcustomers",
    component: () =>
      import(
        "../components/masters/groupCustomersMaster/GroupCustomersList.vue"
      ),
    meta: { requiresAuth: true },
  },

  {
    path: "/categories",
    component: () => import("../components/masters/categories/Categories.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/subcategories",
    component: () =>
      import("../components/masters/subcategories/Subcategories.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/itemGroups",
    component: () => import("../components/masters/itemGroups/ItemGroups.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/orders",
    component: () => import("../components/order/Orders.vue"),
    meta: { requiresAuth: true },
  },
  
  {
    path: "/verifyemail",
    name: "verifyemail",
    component: () => import("../components/masters/apiEmail/VerifyEmail.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/changepassword",
    name: "changepassword",
    component: () => import("../components/masters/apiEmail/ChangePassword.vue"),
    meta: { requiresAuth: true },
  },

    {
    path: "/catalog",
    name: "catalog",
    component: () => import("../components/catalog/Catalog.vue"),
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // ตรวจสอบว่าหน้าต้องการการล็อกอินหรือไม่
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  // รอให้ Firebase ตรวจสอบผู้ใช้ปัจจุบัน
  auth.onAuthStateChanged(async (user) => {
    if (user) {
      try {
        await user.getIdToken(false); // true เพื่อบังคับ refresh

        if (!requiresAuth) {
          next("/");
        } else {
          next();
        }
      } catch (error) {
        console.error("Error refreshing token:", error);
        next("/login"); // ในกรณีที่เกิดปัญหา เช่น refreshToken หมดอายุ
      }
    } else {
      if (requiresAuth) {
        next("/login");
      } else {
        next();
      }
    }
  });
});
export default router;
